import NotificationModal from "./NotificationModal";

export default NotificationModal;
